<template>
  <section :class="$style.year">
    <p :class="$style.year__age">{{ deltaYearString }}/{{ age }}歳</p>
    <li v-for="(event, index) in row.events" :key="index">
      <p :class="$style.year__lifeEvent">{{ event }}</p>
    </li>
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{
  row: {
    deltaYear: number
    events: string[]
  }
  currentAge: number
}>()

const deltaYearString =
  props.row.deltaYear === 0 ? '現在' : `${props.row.deltaYear}年後`

const age = props.currentAge + props.row.deltaYear
</script>

<style lang="scss" module>
.year {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  padding: 0 0 8px 8px;
  border-left: 2px solid $color-blue-700;

  &__age {
    font-size: 10px;
    line-height: 1;
  }

  &__lifeEvent {
    font-size: 12px;
    font-weight: bold;
    line-height: 1;
  }
}
</style>
